__turbopack_context__.v({
  "ajaxResponse": "contact-module__krtVhq__ajaxResponse",
  "badge": "contact-module__krtVhq__badge",
  "cardTitle": "contact-module__krtVhq__cardTitle",
  "contactArea": "contact-module__krtVhq__contactArea",
  "contactCard": "contact-module__krtVhq__contactCard",
  "contactContent": "contact-module__krtVhq__contactContent",
  "contactGrid": "contact-module__krtVhq__contactGrid",
  "contactHeader": "contact-module__krtVhq__contactHeader",
  "contactIcon": "contact-module__krtVhq__contactIcon",
  "contactItem": "contact-module__krtVhq__contactItem",
  "contactLink": "contact-module__krtVhq__contactLink",
  "contactList": "contact-module__krtVhq__contactList",
  "contactSubtitle": "contact-module__krtVhq__contactSubtitle",
  "contactTitle": "contact-module__krtVhq__contactTitle",
  "container": "contact-module__krtVhq__container",
  "day": "contact-module__krtVhq__day",
  "formDescription": "contact-module__krtVhq__formDescription",
  "hoursItem": "contact-module__krtVhq__hoursItem",
  "hoursList": "contact-module__krtVhq__hoursList",
  "hoursTitle": "contact-module__krtVhq__hoursTitle",
  "socialLink": "contact-module__krtVhq__socialLink",
  "socialLinks": "contact-module__krtVhq__socialLinks",
  "socialSection": "contact-module__krtVhq__socialSection",
  "socialTitle": "contact-module__krtVhq__socialTitle",
  "time": "contact-module__krtVhq__time",
  "workingHours": "contact-module__krtVhq__workingHours",
});
